<template>
  <div>
    <div class="comment-list-body-wrap">
      <el-link :href="comment.author_url" :underline="false" target="_blank">
        <el-avatar size="large" :src="comment.author_logo"></el-avatar>
      </el-link>

      <div class="body-header-wrap">

        <div class="user-comment-wrap">

          <i class="far fa-calendar-alt"></i>
          <ul class="comment-list-body__date-wrap">
            <li class="comment-list-body__date-wrap-item">
              {{getCommentDate(comment.post)}}
            </li>
            <li class="comment-list-body__date-wrap-item">
              {{getCommentTime(comment.post)}}
            </li>
            <li class="comment-list-body__date-wrap-item">
            <span class="comment-list-body__date-wrap-item--like">
              <i class="fas fa-thumbs-up"></i> {{comment.likes}}
            </span>
            </li>
          </ul>

          <div class="user-comment-wrap__author">
            <el-link :href="comment.author_url" :underline="false" target="_blank">
              <i class="fas fa-user"></i> <span class="user-comment-wrap__author-item">{{comment.author}}</span>
            </el-link>
          </div>
        </div>

        <div class="comment-list-body__date-wrap-switch">
          <trust
            :trust="getTrust(comment)"
            @setTrust="setTrust"
          />
        </div>

      </div>
    </div>
    <div :class="`${comment.images.length ? 'body-header-text' : ''}`" style="padding-right: 10px">
      {{comment.text}}
    </div>

    <gallery :images="comment.images"/>

    <el-divider />

    <comment-post :post="comment.post" @showMore="showMore" @setTrust="setPostTrust"/>
  </div>
</template>

<script>
  // library
  import moment from 'moment';

  // components
  import Trust from './Trust';
  import CommentPost from './CommentPost';
  import Gallery from './Gallery';

  export default {
    name: "CommentListBody",
    props: {
      comment: {
        type: Object
      }
    },
    data() {
      return {
        trust: true,
      };
    },
    methods: {
      showMore(post) {
        this.$emit('showMore', post);
      },
      getTrust(comment) {
        if (!comment.trust_coment) {
          return 0;
        } else {
          return Number(comment.trust_coment);
        }
      },
      setPostTrust({post, trust}) {
        this.$emit('setPostTrust', {
          post_id: post.id,
          owner_id: post.owner_id,
          network_id: post.network_id,
          trust: trust
        });
      },
      setTrust (trust) {
        this.$emit('setTrust', {
          commentId: this.comment.id,
          postId: this.comment.post.id,
          trust,
          owner_id: this.comment.post.owner_id,
          network_id: this.comment.post.network_id
        });
      },
      getCommentDate(comment) {
        return moment(comment.created_date).format("DD.MM.YY");
      },
      getCommentTime(comment) {
        return moment(comment.created_date).format("HH:mm:ss");
      },
    },
    components: {
      Trust,
      CommentPost,
      Gallery,
    },
  };
</script>

<style>
  .comment-list-body-wrap {
    display: flex;
    font-family: "Roboto", "Arial", sans-serif;
    margin-bottom: 10px;
  }
  .user-comment-wrap {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }
  .user-comment-wrap__author {
    width: 110%;
    margin-top: 6px;
  }
  .user-comment-wrap__author-item {
    margin-left: 12px;
    font-family: "Roboto", "Arial", sans-serif;
    font-weight: 300;
    font-size: 14px;
  }
  .comment-list-body__date-wrap {
    padding: 0;
    margin: 0 0 0 10px;
    list-style: none;
    display: flex;
    font-weight: 300;
    font-size: 12px;
  }
  .body-header-wrap {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    margin-left: 20px;
    flex-grow: 1;
  }
  .comment-list-body__date-wrap-item {
    margin-right: 10px;
  }
  .comment-list-body__date-wrap-item:last-child {
    margin: 0;
  }
  .comment-list-body__date-wrap-item--like {
    display: inline-block;
    margin-left: 20px;
  }
  .comment-list-body__date-wrap-switch {
    margin-left: auto;
  }
  .body-header-text {
    margin-bottom: 15px;
  }
</style>
